import { render, staticRenderFns } from "./gameResultSportsbookTab.vue?vue&type=template&id=32921dbc&scoped=true&lang=pug"
import script from "./gameResultSportsbookTab.vue?vue&type=script&lang=js"
export * from "./gameResultSportsbookTab.vue?vue&type=script&lang=js"
import style0 from "./gameResultSportsbookTab.vue?vue&type=style&index=0&id=32921dbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32921dbc",
  null
  
)

export default component.exports